/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    B2BOrgUnitList,
    instanceOfB2BOrgUnitList,
    B2BOrgUnitListFromJSON,
    B2BOrgUnitListFromJSONTyped,
    B2BOrgUnitListToJSON,
} from './B2BOrgUnitList';
import {
    B2BUnitNodeList,
    instanceOfB2BUnitNodeList,
    B2BUnitNodeListFromJSON,
    B2BUnitNodeListFromJSONTyped,
    B2BUnitNodeListToJSON,
} from './B2BUnitNodeList';

/**
 * @type GetOrgUnits200Response
 * 
 * @export
 */
export type GetOrgUnits200Response = B2BOrgUnitList | B2BUnitNodeList;

export function GetOrgUnits200ResponseFromJSON(json: any): GetOrgUnits200Response {
    return GetOrgUnits200ResponseFromJSONTyped(json, false);
}

export function GetOrgUnits200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrgUnits200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return { ...B2BOrgUnitListFromJSONTyped(json, true), ...B2BUnitNodeListFromJSONTyped(json, true) };
}

export function GetOrgUnits200ResponseToJSON(value?: GetOrgUnits200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfB2BOrgUnitList(value)) {
        return B2BOrgUnitListToJSON(value as B2BOrgUnitList);
    }
    if (instanceOfB2BUnitNodeList(value)) {
        return B2BUnitNodeListToJSON(value as B2BUnitNodeList);
    }

    return {};
}

